interface HotDealPrice {
  normalPrice?: number | null;
  discountPrice?: number | null;
  discountRate?: number | null;
}

export const resolveHotDealPrice = ({
  normalPrice,
  discountPrice,
  discountRate,
}: HotDealPrice) => {
  if (
    typeof discountPrice === 'number' &&
    typeof normalPrice === 'number' &&
    discountPrice < normalPrice
  ) {
    return { price: discountPrice, discountRate: discountRate || null };
  }

  return { price: normalPrice ?? null, discountRate: null };
};

interface HotDealIdentity {
  affiliateHotDealId?: string;
  merchantCode?: string;
}

export const resolveIdentifiedHotDeal = <T extends HotDealIdentity>({
  affiliateHotDealId,
  merchantCode,
  ...hotDeal
}: T) =>
  affiliateHotDealId && merchantCode
    ? [{ ...hotDeal, affiliateHotDealId, merchantCode }]
    : [];
